<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划新增单{{ mode === 'edit' ? '' : '新建' }}</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="mode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL']) && !conditions.plan_order">
          <form-button
            type="primary"
            @click="changeStatus('SAVE')"
          >保存</form-button>
          <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
        </template>

        <template v-if="conditions.plan_order">
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E006' && !showEdit">
              <form-button @click="copyOrder">复制</form-button>
            </template>
            <template v-else>
              <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
              <form-button v-if="!showEdit" @click="copyOrder">复制</form-button>
            </template>
          </template>
        </template>

        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="showEdit = false">显示</form-button>
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E001'">
              <form-button
                type="primary"
                @click="changeStatus('SAVE')"
              >保存</form-button>
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E002'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E005'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E003'">
            <template v-if="$_has(['WLYALL', 'WLY002'])">
              <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
              <form-button @click="changeStatus('REJECT')">审核拒绝</form-button>
            </template>
            <template v-if="$_has(['WLYALL', 'WLY002', 'WLY004'])">
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E004' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        :disabled="isEdit"
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input
                v-model="conditions.plan_order"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划新增单" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划编号">
              <el-input v-model="conditions.plan_number" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="提报类型" prop="report_type">
              <el-select v-model="conditions.report_type" clearable placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0001']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号" prop="customer">
              <wly-input
                v-model="conditions.customer"
                input-type="customer"
                @enter="handleEnter"
                @handleSuffixClick="openDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.cust_name"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.customer_type"
                placeholder=""
                type="text"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="plan_type">
              <el-select v-model="conditions.plan_type" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类" prop="wlybrand">
              <el-select v-model="conditions.wlybrand" placeholder="" filterable>
                <el-option
                  v-for="item in selectDataOptions['A0019']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度" prop="gjahr">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月份" prop="monat">
              <el-select v-model="conditions.monat" placeholder="">
                <el-option value="01" label="01" />
                <el-option value="02" label="02" />
                <el-option value="03" label="03" />
                <el-option value="04" label="04" />
                <el-option value="05" label="05" />
                <el-option value="06" label="06" />
                <el-option value="07" label="07" />
                <el-option value="08" label="08" />
                <el-option value="09" label="09" />
                <el-option value="10" label="10" />
                <el-option value="11" label="11" />
                <el-option value="12" label="12" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约审批单号" prop="approval_no">
              <el-input
                v-model="conditions.approval_no"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                clearable
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="计划量" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划量（件)" prop="initplan_qty">
                  <el-input
                    v-model="conditions.initplan_qty"
                    type="text"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="计划量" style="visibility:hidden"/>
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划量（瓶)" prop="initplan_bot">
                  <el-input
                    v-model="conditions.initplan_bot"
                    type="text"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="计划额(参考)" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="初始计划额（万元）">
                  <el-input
                    v-model="conditions.initplan_amt"
                    type="text"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <el-select
                v-model="conditions.sal_center"
                type="text"
                placeholder=""
                clearable
                :disabled="!selectDataOptions.orgList || selectDataOptions.orgList.length == 1"
                @change="changeSalesCenter"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.sal_base_text" type="text" clearable disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input v-model="conditions.region_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.city_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                v-model="conditions.sales_emp_name"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select v-model="conditions.porder_status" placeholder="" clearable disabled>
                <el-option
                  v-for="item in selectDataOptions['A0025']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input v-model="conditions.audit_comment" type="textarea" rows="4" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog v-dialogDrag :visible.sync="showDialog" width="70%" title="客户选择">
      <client-select v-if="showDialog" ref="dialogSelect" />
      <div slot="footer">
        <el-button
          icon="el-icon-circle-close"
          type="default"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          icon="el-icon-circle-check"
          type="primary"
          size="small"
          @click="submitHandle"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanByNumber, apiSalePlanCreate } from '@/api/sap/sale-plan'
import { apiSapClientFindInfo } from '@/api/common'
import { mapGetters } from 'vuex'
import { formatSapFileSize } from '@/mixins/index'
import { sapDownloadFile } from '@/utils/frontExport'
import ClientSelect from '../../components/dialog/ClientSelect.vue'

export default {
  components: {
    ClientSelect
  },
  data() {
    const rules = {
      report_type: [{ required: true, message: '请选择提报类型', trigger: 'change' }],
      plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
      initplan_qty: [{ required: true, message: '请选择初始计划量', trigger: 'change' }],
      sal_center: [{ required: true, message: '请选营销中心', trigger: 'change' }],
      monat: [{ required: true, message: '请选择月份', trigger: 'change' }],
      gjahr: [{ required: true, message: '请选择年度', trigger: 'change' }],
      wlybrand: [{ required: true, message: '请选择存货分类', trigger: 'change' }],
      customer: [{ required: true, message: '请选择客户编码', trigger: 'change' }]
    }
    return {
      rules,
      mode: 'add',
      showEdit: false,
      showDialog: false,
      selectDataOptions: {},
      loading: false,
      provinceList: [],
      errorList: [],
      cityList: [],
      conditions: {
        id: '',
        uname: '',
        datum: '',
        porder_status: 'E001',
        plan_order: '',
        order_type: 'ZP01',
        plan_number: '',
        report_type: '',
        customer: '',
        customer_type: '',
        cust_name: '',
        plan_type: '',
        wlybrand: '',
        gjahr: '',
        monat: '',
        sal_center: '',
        sal_base: '',
        region: '',
        region_text: '',
        city: '',
        city_text: '',
        sales_emp: '',
        sales_emp_name: '',
        initplan_qty: '',
        initplan_amt: '',
        remark: '',
        audit_comment: '',
        sal_base_text: ''
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名称', slots: { default: 'filename' }},
          { field: 'mimetype', title: '附件类型' },
          {
            field: 'filelength',
            title: '大小',
            formatter: ({ cellValue }) => formatSapFileSize(cellValue)
          },
          {
            field: 'created_date',
            title: '上传日期',
            formatter: ({ cellValue }) => {
              if (!cellValue) return ''
              const dateStr = String(cellValue)
              if (dateStr.length === 8) {
                return dateStr.substring(0, 4) + '-' + dateStr.substring(4, 6) + '-' + dateStr.substring(6, 8)
              }
              return cellValue
            }
          },
          {
            field: 'created_time',
            title: '上传时间',
            formatter: ({ cellValue }) => {
              if (!cellValue) return ''
              const timeStr = String(cellValue)
              if (timeStr.length === 6) {
                return timeStr.substring(0, 2) + ':' + timeStr.substring(2, 4) + ':' + timeStr.substring(4, 6)
              }
              return cellValue
            }
          }
        ],
        data: [],
        delData: []
      }
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      if (this.conditions.plan_order) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  created() {
    // 销售计划变更原因 字典：A0003
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0001')
    this.getSelectDictDataOrigin('A0025')
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0009')
    const params = this.$route.params
    // 变更编辑单
    if (this.$route.query.order && !Reflect.ownKeys(params).length) {
      this.mode = 'edit'
      this.salePlanCountFindById()
    } else if (Reflect.ownKeys(params).length) {
      Object.assign(this.conditions, params)
      this.initCustomer()
      this.conditions.uname = this.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    } else {
      this.conditions.uname = this.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      if (this.role.ROLE === 'WLY001') {
        const { info, yxdy } = this.customerInfo
        this.conditions.customer = info.partner
        this.conditions.cust_name = info.name_org1
        this.conditions.customer_type = info.zzfld000016
        this.conditions.sales_emp_name = info.sales_emp_name
        this.conditions.sales_emp = info.sales_emp
        this.conditions.region = info.region
        this.conditions.region_text = info.bezei
        this.conditions.city = info.city_code
        this.conditions.city_text = info.city_name
        this.selectDataOptions['orgList'] = yxdy
      }
    }
  },

  methods: {
    copyOrder() {
      const resetFields = [
        'plan_order',
        'plan_number',
        'futur_adjqty',
        'futur_adjamt',
        'change_name',
        'uzeit',
        'timestamp',
        'mdate',
        'mtime',
        'mname',
        'mtimestamp',
        'porder_status'
      ]
      if (this.mode === 'add') {
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            this.conditions[key] = 'E001'
          } else {
            this.conditions[key] = ''
          }
        })
        this.gridOptions.data = []
        this.gridOptionsFile.data = []
        this.gridOptionsFile.delData = []
        this.showEdit = false
      } else {
        const params = { ...this.conditions }
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            params[key] = 'E001'
          } else {
            params[key] = ''
          }
        })
        this.$router.replace({
          name: '10.01 销售计划新增单创建',
          params
        })
      }
    },
    changeSalesCenter(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.sal_base = checkedData.zzfld00003e || ''
      this.conditions.sal_base_text = checkedData.mc_short_jd || ''
    },
    // 保存 提交 取消
    changeStatus(mode) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          const params = {
            iv_mode: mode,
            user_bp: this.role.USER_BP,
            data: this.conditions,
            history: this.gridOptions.data,
            attachment: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
          }
          this.errorList = []
          const res = await apiSalePlanCreate(params)
          if (res.msgtype === 'E') {
            this.errorList.push(res.message)
            return
          }
          this.$message.success(res.message)
          Object.assign(this.conditions, res.info)
          this.showEdit = false
          this.conditions.cancel = res.cancel
          this.gridOptions.data = res.history
          this.gridOptionsFile.delData = []
          if (res.attachment) {
            this.gridOptionsFile.data = res.attachment
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    async salePlanCountFindById() {
      const { data } = await getSalePlanByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data?.ls_head || {})
      this.conditions.cancel = data.cancel
      this.initCustomer()
      this.gridOptions.data = data?.lt_chg_history || []
      this.gridOptionsFile.data = data?.attachment || []
    },
    async initCustomer() {
      const params = {
        rt_partner: [
          {
            SIGN: 'I',
            OPTION: 'EQ',
            LOW: this.conditions.customer,
            HIGH: ''
          }
        ],
        page: 1,
        pagesize: 50
      }
      // 当前登录账号和角色
      params.partner = this.role.USER_BP
      params.role = this.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      if (data.length) {
        this.conditions.sales_emp_name = data[0].sales_emp_name
        this.conditions.sales_emp = data[0].sales_emp
        this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          if (dictcode === 'A0019') {
            response.data.Rows.forEach(item => {
              item.name += '  |  ' + item.value
            })
          }
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 打开窗口
    openDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.conditions.customer = data.customerCode
        this.conditions.cust_name = data.customerName
        this.conditions.customer_type = data.customerType
        this.conditions.sales_emp_name = data.sales_emp_name
        this.conditions.sales_emp = data.sales_emp
        this.conditions.region = data.region
        this.conditions.region_text = data.bezei
        this.conditions.city = data.city_code
        this.conditions.city_text = data.city_name
        this.resetConditions()
        this.$set(this.selectDataOptions, 'orgList', data.orgList)
        this.conditions.sal_center = ''
        this.conditions.sal_base = ''
        this.conditions.sal_base_text = ''
        if (data.orgList.length === 1) {
          this.conditions.sal_center = data.orgList[0].zzfld00001h
          this.conditions.sal_base = data.orgList[0].zzfld00003e
          this.conditions.sal_base_text = data.orgList[0].mc_short_jd
        }
      }
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.customer = data.customerCode
          this.conditions.cust_name = data.customerName
          this.conditions.customer_type = data.customerType
          this.conditions.sales_emp_name = data.sales_emp_name
          this.conditions.sales_emp = data.sales_emp
          this.conditions.region = data.region
          this.conditions.region_text = data.bezei
          this.conditions.city = data.city_code
          this.conditions.city_text = data.city_name
          this.resetConditions()
          this.$set(this.selectDataOptions, 'orgList', data.orgList)
          this.conditions.sal_center = ''
          this.conditions.sal_base = ''
          this.conditions.sal_base_text = ''
          if (data.orgList.length === 1) {
            this.conditions.sal_center = data.orgList[0].zzfld00001h
            this.conditions.sal_base = data.orgList[0].zzfld00003e
            this.conditions.sal_base_text = data.orgList[0].mc_short_jd
          }
          break
      }
    },
    resetConditions() {
      this.conditions.sal_center = ''
      this.conditions.sal_base_text = ''
      this.conditions.sal_base = ''
    },
    // 获取文件后缀
    getFileExtension(filename) {
      const parts = filename.split('.')
      return parts.length > 1 ? parts.pop().toLowerCase() : ''
    },
    // 上传文件
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        const dateTime = new Date().getTime()
        const fileExtension = _this.getFileExtension(file.name)
        const fileData = {
          filename: file.name,
          mimetype: fileExtension,
          doc_type: fileExtension,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.role.USER_BP,
          zzfld00002d_dscr: _this.role.login_user,
          created_date: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          created_time: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 删除附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      if (this.conditions.plan_order) {
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(
          checkedList.filter(v => v.attach_id)
        )
      }
    },
    // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 24px 16px;
  background: #ffffff;
}
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanEdit.vue